import React from 'react';
import '../Article/ArticleModules/ImageModule/image-module.scss';
import { isValid, isText, decodeTags, decodeSpecialCharacters, getRelValue } from '../../utils';

const getIsButton = (button) => {
  let { text, url } = button;
  if (isText(text) && isText(url)) {
    return true;
  }
  return false;
};

const hasOldPrice = (button) => {
  const { oldPrice } = button;
  if (isText(oldPrice)) {
    return true;
  }
  return false;
};

const hasPrice = (button) => {
  const { price } = button;
  if (isText(price)) {
    return true;
  }
  return false;
};

const Button = ({
  button,
  sponsoredRel,
  isStandard,
}) => {
  let { text, url, price, oldPrice } = button;
  const buttonClassName = isStandard ? 'button button-text standard' : 'button button-text';
  const isButton = getIsButton(button);
  const buttonRel = getRelValue(url);
  
  const renderedOldPrice = hasOldPrice(button) ? <span className='old-price'><span>{oldPrice}</span>,&nbsp;</span> : '';

  const renderedPrice = hasPrice(button) ? <span className='button-text'>({renderedOldPrice}{price})</span> : null;

  const renderedText = (isText(text) && isValid(renderedPrice)) ? <span>{text}<span>&nbsp;</span>{renderedPrice}</span> : <span>{text}</span>;

  return (isText(text) && isText(url)) && <a className={buttonClassName} href={decodeSpecialCharacters(url)} data-link-type="cta-link" target="_blank" rel={buttonRel}>{renderedText}</a>;
};

export default Button;
